import type { JSX } from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  title?: string;
}

/**
 * NerdyBot mark — the canonical chat persona.
 *
 * A friendly chat-bubble face: rounded body with a tail, a small
 * antenna with a pearl, two big white eyes with raspberry pupils,
 * and a soft smile — all on the Aurora Paper raspberry → peach
 * gradient (`#D6336C → #FF8A65`). This is the design captured in
 * `tmp/platform-mockups/logos.html` and is what NerdyBot wears in
 * the chat widget header, welcome state, and admin pages.
 */
export function NerdyBotLogo({
  size = 48,
  className,
  title = 'NerdyBot',
}: LogoProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <defs>
        <linearGradient id="nb-mark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#D6336C" />
          <stop offset="100%" stopColor="#FF8A65" />
        </linearGradient>
      </defs>
      {/* chat bubble body */}
      <rect x="5" y="5" width="90" height="78" rx="22" fill="url(#nb-mark)" />
      {/* chat bubble tail */}
      <path d="M 22 80 L 14 96 L 40 80 Z" fill="url(#nb-mark)" />
      {/* antenna */}
      <line x1="50" y1="14" x2="50" y2="22" stroke="white" strokeWidth="3" strokeLinecap="round" />
      <circle cx="50" cy="12" r="3.5" fill="white" />
      {/* eyes */}
      <circle cx="36" cy="42" r="7" fill="white" />
      <circle cx="64" cy="42" r="7" fill="white" />
      <circle cx="38" cy="41" r="2" fill="#D6336C" />
      <circle cx="66" cy="41" r="2" fill="#D6336C" />
      {/* smile */}
      <path
        d="M 34 60 Q 50 70 66 60"
        stroke="white"
        strokeWidth="3.5"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
